export default __webpack_public_path__ + "static/media/IELTS.bfaf741e.png";